export const academicPricesTitles = [
  {
    titleName: "id",
    colWidth: "20px",
  },
  { titleName: "Class", colWidth: "80px", key: "className" },
  { titleName: "Admission fee", colWidth: "120px", key: "admission_fee" },
  { titleName: "Annual fee", colWidth: "90px", key: "annual_fee" },
  { titleName: "Extra class fee", colWidth: "110px", key: "extra_class_fee" },
  { titleName: "Montly fee", colWidth: "80px", key: "monthly_fee" },
  { titleName: "Stationary fee", colWidth: "100px", key: "stationery_fee" },
  { titleName: "Exam fee", colWidth: "70px", key: "exam_fee" },
  {
    titleName: "Extra circulum fee",
    colWidth: "150px",
    key: "extra_carricular_fee",
  },
];
